import React, { memo, useCallback, useEffect, useState } from 'react';
import cx from 'classnames';

const styles = require('./index.less');

const noop = () => {};

const CommonFooterModal = ({ className, showTrigger = true, onVisibleChange = noop }) => {
  const [visible, setVisible] = useState(false);

  const openFooter = useCallback(
    () => {
      setVisible(true);
      onVisibleChange(true);
    },
    [onVisibleChange]
  );

  const closeFooter = useCallback(
    () => {
      setVisible(false);
      onVisibleChange(false);
    },
    [onVisibleChange]
  );

  useEffect(
    () => {
      const previousConfig = window.OMNI__COMMON__FOOTER;
      const footerConfig = Object.assign({}, previousConfig, { to_top_handler: closeFooter });
      window.OMNI__COMMON__FOOTER = footerConfig;

      if (typeof window.init_OMNI__COMMON__FOOTER === 'function') {
        window.init_OMNI__COMMON__FOOTER();
      }

      return () => {
        onVisibleChange(false);
        if (window.OMNI__COMMON__FOOTER === footerConfig) {
          window.OMNI__COMMON__FOOTER = previousConfig;
        }
      };
    },
    [closeFooter, onVisibleChange]
  );

  useEffect(
    () => {
      if (!visible) {
        return undefined;
      }

      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = previousOverflow;
      };
    },
    [visible]
  );

  return (
    <React.Fragment>
      {showTrigger && <button type="button" className={cx(styles.trigger, className)} onClick={openFooter} aria-label="版权信息" />}
      <div
        className={cx(styles.mask, visible && styles.visible)}
        onClick={event => {
          if (event.target === event.currentTarget) {
            closeFooter();
          }
        }}
      >
        <div className={styles.panel}>
          <div className={styles.footerContent} id="OMNI__COMMON__FOOTER" />
        </div>
      </div>
    </React.Fragment>
  );
};

export default memo(CommonFooterModal);
